import {Directive, EventEmitter, OnInit, Output} from '@angular/core';

@Directive({
    selector: '[dbLoaded]',
    standalone: false
})
export class LoadedDirective implements OnInit {

  @Output() loaded: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.loaded.emit();
    this.loaded = null;
  }

}
